import type {
  Script,
  ScriptCreateDto,
  ScriptUpdateDto,
  ScriptTestDto,
  ScriptBulkLogMessages,
  ScriptLogMessage,
  ScriptExample,
} from "~/types/api";
import type { ApiResponse } from "~/types/ui";
import { BaseAPI } from "./base";

export class ScriptApi extends BaseAPI {
  async getScripts(): Promise<ApiResponse<Script[]>> {
    return this.get<Script[]>(`script/company/${this.company()}`);
  }

  async getScript(scriptId: number): Promise<ApiResponse<Script>> {
    return this.get<Script>(`script/${scriptId}`);
  }

  async createScript(payload: ScriptCreateDto): Promise<ApiResponse<void>> {
    return this.post<void>(`script/${this.company()}`, payload);
  }

  async updateScript(
    scriptId: number,
    payload: ScriptUpdateDto,
  ): Promise<ApiResponse<void>> {
    return this.put<void>(`script/${scriptId}`, payload);
  }

  async createScripts(payload: ScriptCreateDto[]): Promise<ApiResponse<void>> {
    return this.post<void>(`script/bulk/${this.company()}`, payload);
  }

  async createOrUpdateScripts(
    payload: ScriptUpdateDto[],
  ): Promise<ApiResponse<void>> {
    return this.put<void>(`script/bulk/${this.company()}`, payload);
  }

  async deleteScript(scriptId: number): Promise<ApiResponse<void>> {
    return this.delete<void>(`script/${scriptId}`);
  }

  async deleteScripts(scriptIds: number[]): Promise<ApiResponse<void>> {
    return this.post<void>(`script/bulk-delete`, scriptIds);
  }

  async testScript(
    payload: ScriptTestDto,
  ): Promise<ApiResponse<ScriptLogMessage[] | string>> {
    return this.post<ScriptLogMessage[] | string>(
      `script/test/${this.company()}`,
      payload,
    );
  }

  async testScripts(
    payload: ScriptTestDto[],
  ): Promise<ApiResponse<ScriptBulkLogMessages | string>> {
    return this.post<ScriptBulkLogMessages | string>(
      `script/test/bulk/${this.company()}`,
      payload,
    );
  }

  async getScriptExamples(): Promise<ApiResponse<ScriptExample[]>> {
    return this.get<ScriptExample[]>(`script/examples`);
  }

  async executeScript(scriptId: number): Promise<ApiResponse<void>> {
    return this.get<void>(`script/run/${scriptId}`);
  }
}
